import {createSlice} from '@reduxjs/toolkit';

// ---- import from local actions ----
import {fetchBuildingSelection, fetchBuildingList} from './../actions/BuildingActions';


const BuildingSlice = createSlice({
  name: 'building',
  initialState: {
    buildingSelection: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
    buildingList: {
      data: [],
      status: 'idle',
      error: '',
      loading: false,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchBuildingSelection.pending, (state) => {
        state.buildingSelection.status = 'loading';
      })
      .addCase(fetchBuildingSelection.fulfilled, (state, action) => {
        state.buildingSelection.status = 'idle';
        state.buildingSelection.data = action.payload.result;
      })
      .addCase(fetchBuildingSelection.rejected, (state, action) => {
        state.buildingSelection.status = 'rejected';
        state.buildingSelection.error = action.error.message;
      })

      .addCase(fetchBuildingList.pending, (state) => {
        state.buildingList.status = 'loading';
      })
      .addCase(fetchBuildingList.fulfilled, (state, action) => {
        state.buildingList.status = 'idle';
        state.buildingList.data = action.payload.result;
      })
      .addCase(fetchBuildingList.rejected, (state, action) => {
        state.buildingList.status = 'rejected';
        state.buildingList.error = action.error.message;
      });
  },
});


export default BuildingSlice.reducer;
